<template>
    <div v-if="festa">
        <section class="text-left">
            <h2>행사 소개</h2>
            <b v-html="festa.section2.txt[0]?.replace(/\n/g, '<br/>')" />
            <p v-html="festa.section2.txt[1]?.replace(/\n/g, '<br/>')" />
        </section>

        <section class="text-left">
            <h2>행사 개요</h2>
            <table>
                <tbody>
                    <template v-for="item, index in festa.section3.table.list">
                        <tr :key="index">
                            <td><p v-html="item.title.replace(/\n/g, '<br />')" /></td>
                            <td><p v-html="item.input.replace(/\n/g, '<br />')" /></td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </section>

        <section class="text-left d-block">
            <h2>개최성과</h2>
            <p v-html="festa.section4.txt[0]" />
        </section>

        <section class="text-left d-block">
            <h2>프로그램</h2>
            <p v-html="festa.section5.txt[0]" />
        </section>

        <section class="text-left d-block">
            <h2>Partners</h2>
            <p v-html="festa.section6.contents.frame2211.txt[0]" />

            <template v-for="logoItems, row in festa.section6.contents.frame2302.logoList">
                <v-row :key="row">
                    <template v-for="{ src, url }, col in logoItems">
                        <v-col cols="3" :key="col">
                            <a :href="url">
                                <v-img :src="src" contain height="96" />
                            </a>
                        </v-col>
                    </template>
                    <v-spacer />
                </v-row>
            </template>
        </section>
    </div>
</template>

<script>
import api from "@/api";

export default {
    data(){
        return {
            festa: null
        }
    },
    mounted(){
        this.init();
    },

    methods: {
        async init(){
            let { festa } = await api.v1.kea.festa.get();
            this.festa = festa;
        }
    }
}
</script>